import React from "react";

export const OpenAIIcon = (props) => (
  <img 
    src="https://cdn.simpleicons.org/openai/white" 
    alt="OpenAI" 
    {...props} 
  />
);

export const N8NIcon = (props) => (
  <img 
    src="https://cdn.simpleicons.org/n8n/FF6D5A" 
    alt="n8n" 
    {...props} 
  />
);

export const GoogleDriveIcon = (props) => (
  <img 
    src="https://cdn.simpleicons.org/googledrive" 
    alt="Google Drive" 
    {...props} 
  />
);

export const ClaudeIcon = (props) => (
  <img 
    src="https://cdn.simpleicons.org/anthropic/white" 
    alt="Claude" 
    {...props} 
  />
);

export const GmailIcon = (props) => (
  <img 
    src="https://cdn.simpleicons.org/gmail" 
    alt="Gmail" 
    {...props} 
  />
);

export const WhatsAppIcon = (props) => (
  <img 
    src="https://cdn.simpleicons.org/whatsapp/25D366" 
    alt="WhatsApp" 
    {...props} 
  />
);
